import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-sky-700 dark:from-gray-900 dark:to-gray-800">
      {/* Welcome Message */}
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white"> 
            Welcome to EvereadyGas
          </h1>
          <p className="mt-3 text-lg text-gray-600 dark:text-gray-300">
            Find the best gas solutions for your home and business
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Category Buttons */}
        <div className="flex justify-center gap-4 mb-8">
          <button
            onClick={() => navigate("/gas-cylinders")}
            className="px-8 py-3 bg-sky-800 text-white rounded-lg hover:bg-sky-800 transition-colors font-medium shadow-md hover:shadow-lg"
          >
            View All Gas Cylinders
          </button>
          <button
            onClick={() => navigate("/accessories")}
            className="px-8 py-3 bg-sky-800 text-white rounded-lg hover:bg-sky-800 transition-colors font-medium shadow-md hover:shadow-lg"
          >
            View All Accessories
          </button>
        </div>

        {/* Category Cards */}
        <div className="flex flex-row justify-center gap-6">
          {/* Gas Category */}
          <div
            onClick={() => navigate("/gas-cylinders")}
            className="relative w-60 h-96 rounded-lg overflow-hidden cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm"
          >
            <img
              src="https://uploads.jumuiyaenergy.com/images/EcommerceImage20250208at060725pm3o06muba_Supagas.jpg"
              alt="Gas Cylinders"
              className="w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h2 className="text-lg font-bold text-green-600 mb-1">
                Gas Cylinders
              </h2>
              <p className="text-white/80 text-sm mb-2">
                Wide range of LPG cylinders from trusted brands
              </p>
              <button className="flex items-center text-secondary-400 text-sm font-semibold group-hover:text-secondary-300">
                Shop Now <ChevronRight className="h-4 w-4 ml-1" />
              </button>
            </div>
          </div>

          {/* Accessories Category */}
          <div
            onClick={() => navigate("/accessories")}
            className="relative w-60 h-796 rounded-lg overflow-hidden cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm"
          >
            <img
              src="https://uploads.jumuiyaenergy.com/images/BlinkImage20240520at024033pmwzro8vst.jpg"
              alt="Gas Accessories"
              className="w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h2 className="text-lg font-bold text-green-600 mb-1">
                Accessories
              </h2>
              <p className="text-white/80 text-sm mb-2">
                Essential accessories for safe gas usage
              </p>
              <button className="flex items-center text-secondary-400 text-sm font-semibold group-hover:text-secondary-300">
                Shop Now <ChevronRight className="h-4 w-4 ml-1" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
